import { ReactNode } from 'react'
import { Gem } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import LinkButton from '@/components/ui/link-button'
import { cn } from '@/lib/utils'

type Props = {
  title: ReactNode
  description: ReactNode
  to?: string
  onNavigate?: () => void
  actionLabel?: ReactNode
  className?: string
}

const PremiumUpsell = ({
  title,
  description,
  to,
  onNavigate,
  actionLabel,
  className,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div
      role='note'
      className={cn(
        'flex items-center gap-3 rounded-lg border border-premium-foreground/50 bg-premium p-3',
        className,
      )}
    >
      <Gem className='h-4 w-4 shrink-0 text-premium-foreground' />
      <div className='min-w-0 grow'>
        <div className='text-sm font-medium leading-tight'>{title}</div>
        <div className='text-xs text-muted-foreground'>{description}</div>
      </div>
      {to ? (
        <LinkButton
          to={to}
          size='xs'
          className='shrink-0 border-premium-foreground/60 text-premium-foreground'
          onClick={onNavigate}
        >
          {actionLabel ?? t('shared.premium')}
        </LinkButton>
      ) : null}
    </div>
  )
}

export default PremiumUpsell
